import React from 'react';
import { Link } from 'gatsby';
import DataConsulting from "../images/data-consulting.svg";
import DataEngineering from "../images/data-engineering.svg";
import DataScience from "../images/data-science.svg";
import DataVisualisation from "../images/data-visual.svg";

const services = [
    {
        id: 1,
        title: "Data engineering",
        description: "Designing systems to collect, store, transport and transform your data",
        icon: DataEngineering,
        path: "/services/data-engineering-consulting-services/",
    },
    {
        id: 2,
        title: "Data consulting",
        description: "Understanding the purpose, value, and scale of your organization's data",
        icon: DataConsulting,
        path: "/services/data-analytics-consulting-services/",
    },
    {
        id: 3,
        title: "Data visualization",
        description: "Representing relationships and revealing hidden insights in your data",
        icon: DataVisualisation,
        path: "/services/data-visualization-consulting-services/",
    },
    {
        id: 4,
        title: "Data science",
        description: "Leveraging AI and ML to unlock unprecedented business value",
        icon: DataScience,
        path: "/services/data-science-consulting-services/",
    },
];

const GlossaryServices = () => {
    return (
        <div className="glossary-services container">
            <div className="glossary-services__header">
                <Link to="/services" className="text-p2 font--secondary text-clr-clr-grey-2 text-fw-regular">
                        OUR SERVICES
                </Link>
                <h2 className="text-h2 font--primary gap-1x text-fw-medium text-clr-primary">Catalyzing your data journey</h2>
            </div>
            <div className="glossary-services__list">
                {services.map((service) => (
                    <div key={service.id} className="glossary-services__item">
                        <div className="glossary-services__icon">
                            <img src={service.icon} alt={service.title} />
                        </div>
                        
                        <h3 className="text-h3 font--primary gap-2x text-fw-medium text-clr-primary">{service.title}</h3>
                        <p className="font--secondary text-p3 text-fw-regular text-clr-secondary gap-2x">{service.description}</p>
                        <div className="learn-more-btn  learn-more-btn--small">
                            <Link to={`${service.path}`}>Learn more</Link>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                >
                                    <path
                                        d="M20 10L11 15.1962L11 4.80385L20 10Z"
                                        fill="black"
                                    />
                                    <path d="M14 10L0 10" stroke="black" />
                                </svg>
						</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GlossaryServices;
